// extracted by mini-css-extract-plugin
export default {"loginBg":"ScreenDivider_loginBg__MhK61","medic":"ScreenDivider_medic__lC7ss","patient":"ScreenDivider_patient__mMOjq","clinic":"ScreenDivider_clinic__aby6E"};